/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_ColumnsInputs */

const en_disp_columns = /** @type {(inputs: Disp_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns`)
};

const de_disp_columns = /** @type {(inputs: Disp_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalten`)
};

/**
* | output |
* | --- |
* | "Columns" |
*
* @param {Disp_ColumnsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_columns = /** @type {((inputs?: Disp_ColumnsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_ColumnsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_columns(inputs)
	return en_disp_columns(inputs)
});